import { render, staticRenderFns } from "./InseminationsTab.vue?vue&type=template&id=fdbc46aa&"
import script from "./InseminationsTab.vue?vue&type=script&lang=js&"
export * from "./InseminationsTab.vue?vue&type=script&lang=js&"
import style0 from "./InseminationsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports